import style from "../../../../assets/scss/sub/purchase/orderAndPayment.module.scss";
import {PaymentWay} from "../../../../types/payment";
import React from "react";
import {useTranslation} from "react-i18next";
import {useLanguage} from "../../../../hooks/hooks";

interface Args{
    paymentWay: PaymentWay | null,
    onClickPaymentWayBtn: (_: PaymentWay) => void
}
export function PaymentMethodField({paymentWay, onClickPaymentWayBtn}: Args) {
    const { t } = useTranslation("order");
    const { isKorean } = useLanguage();
    const isCardSelected = (paymentWay === PaymentWay.CARD) || (paymentWay === PaymentWay.PAYPAL)

    return (
        <div className={`${style.paymentWay} ${isKorean ? "" : style.en}`}>
            <h3 className={style.sectionTitle}>{t("paymentMethod.title")}</h3>
            <ul className={style.ways}>
                <button
                    className={`${style.payItem} ${isCardSelected ? style.selected : ""}`}
                    onClick={() => onClickPaymentWayBtn(isKorean ? PaymentWay.CARD : PaymentWay.PAYPAL)}>
                    {t("paymentMethod.card")}
                </button>
                {isKorean && (
                    <button
                        className={`${style.payItem} ${paymentWay === PaymentWay.VBANK ? style.selected : ""}`}
                        onClick={() => onClickPaymentWayBtn(PaymentWay.VBANK)}>
                        {t("paymentMethod.virtualAccount")}
                    </button>
                )}
            </ul>
        </div>
    )
}